import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storeSteps, terminalSteps } from "../../../utils/constant";
import {
  addReportFunction,
  deleteReportFunction,
  getReportFunction,
  updateReportFunction,
} from "./productYourReport.thunk";

const initialState = {
  productYourReports: [],
  loading: true,
};

export const addReportAsyncThunk = createAsyncThunk(
  "reports/addReport",
  addReportFunction
);

export const getReportAsyncThunk = createAsyncThunk(
  "reports/getReport",
  getReportFunction
);

export const updateReportAsyncThunk = createAsyncThunk(
  "reports/updateReport",
  updateReportFunction
);

export const deleteReportAsyncThunk = createAsyncThunk(
  "reports/deleteReport",
  deleteReportFunction
);

const productYourReportsSlice = createSlice({
  name: "productYourReports",
  initialState,
  reducers: {
    addReport: (state, action) => {
      state.productYourReports.push(action.payload);
    },
    updateReport: (state, action) => {
      const { index, report } = action.payload;
      state.productYourReports[index] = report;
    },
    removeReport: (state, action) => {
      const { reportIndex } = action.payload;
      const newState = state.productYourReports.filter(
        (_, i) => i != reportIndex
      );
      state.productYourReports = newState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addReportAsyncThunk.pending, (state, action) => {})
      .addCase(addReportAsyncThunk.fulfilled, (state, action) => {
        state.productYourReports.push(action.payload[0]);
        state.loading = false;
      })
      .addCase(addReportAsyncThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getReportAsyncThunk.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getReportAsyncThunk.fulfilled, (state, action) => {
        state.productYourReports = action.payload;
        state.loading = false;
      })
      .addCase(getReportAsyncThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateReportAsyncThunk.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateReportAsyncThunk.fulfilled, (state, action) => {
        state.productYourReports[action.payload.index] = action.payload.data[0];
        state.loading = false;
      })
      .addCase(updateReportAsyncThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteReportAsyncThunk.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteReportAsyncThunk.fulfilled, (state, action) => {
        state.productYourReports = [
          ...state.productYourReports?.splice(0, action?.payload?.index),
          ...state.productYourReports?.splice(action?.payload?.index + 1),
        ];
        state.loading = false;
      })
      .addCase(deleteReportAsyncThunk.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { addReport, updateReport, removeReport } =
  productYourReportsSlice.actions;

export default productYourReportsSlice.reducer;
